<script setup lang="ts">
import { onActivated, onDeactivated } from 'vue'
import { storeToRefs } from 'pinia'
import { useSettingStore } from '@/stores/settingStore'

interface Props {
	showLeftContainer?: boolean
}

withDefaults(defineProps<Props>(), {
	showLeftContainer: false,
})

const { disableMenuAnimation } = storeToRefs(useSettingStore())

onActivated(() => {
	disableMenuAnimation.value = true
})

onDeactivated(() => {
	disableMenuAnimation.value = false
})
</script>

<template>
	<div class="flex flex-col menusm:flex-row relative min-h-screen">
		<div
			class="container-generator"
			:class="{ 'with-preset': showLeftContainer }"
		>
			<div
				v-if="showLeftContainer"
				class="container-left"
			>
				<slot name="leftContainer" />
			</div>
			<div class="container-right">
				<slot name="rightContainer" />
			</div>
		</div>
		<slot name="content" />
	</div>
</template>

<style scoped lang="scss">
.container-generator {
  @apply rounded-lg menusm:sticky mt-[120px] menusm:mt-0 top-[120px] menu:top-[80px] pt-4 bg-slate-900;
  @apply menu:max-h-[calc(100dvh-80px)] menusm:max-h-[calc(100dvh-120px)];

  @apply menusm:w-[400px] md:w-[450px] lg:w-[500px] xl:w-[550px] 2xl:w-[600px] 3xl:w-[650px];
 	&.with-preset {
	@apply menusm:!w-[600px] md:!w-[650px] lg:!w-[700px] xl:!w-[750px] 2xl:!w-[800px] 3xl:!w-[850px];
  }
  @apply flex flex-row gap-2;
}

.container-left {
  @apply ml-4 min-w-[240px];
}

.container-right {
  @apply menusm:overflow-y-auto px-4 w-full;
}
</style>
